import { componentReferencesComponent } from './queries.js';
import type { AppState } from '../../state/appState.js';

interface InstancePickerActions {
  addBlankInstance: () => void;
  addExistingComponentInstance: (componentId: string) => void;
}

export function closePicker(): void {
  const existing = document.querySelector('.scene-instance-picker');
  if (existing) existing.remove();
  document.removeEventListener('pointerdown', onPickerOutsideClick, true);
}

function onPickerOutsideClick(e: PointerEvent): void {
  const picker = document.querySelector('.scene-instance-picker');
  if (picker && !picker.contains(e.target as Node)) {
    closePicker();
  }
}

export function showInstancePicker(anchor: HTMLElement, appState: AppState, actions: InstancePickerActions): void {
  closePicker();

  const picker = document.createElement('div');
  picker.className = 'scene-instance-picker';

  const emptyItem = document.createElement('div');
  emptyItem.className = 'scene-picker-item';
  emptyItem.textContent = 'Blank component';
  emptyItem.addEventListener('click', () => { closePicker(); actions.addBlankInstance(); });
  picker.appendChild(emptyItem);

  const currentComponentId = appState.activeComponentId;
  const existingIds = Object.keys(appState.componentLibrary).filter(componentId => {
    if (!currentComponentId) return true;
    if (componentId === currentComponentId) return false;
    return !componentReferencesComponent(appState, componentId, currentComponentId);
  });

  if (existingIds.length > 0) {
    const reuseTitle = document.createElement('div');
    reuseTitle.className = 'scene-picker-section-title';
    reuseTitle.textContent = 'Existing components';
    picker.appendChild(reuseTitle);

    const reuseList = document.createElement('div');
    reuseList.className = 'scene-picker-list';

    for (const componentId of existingIds) {
      const component = appState.componentLibrary[componentId];
      if (!component) continue;
      const item = document.createElement('div');
      item.className = 'scene-picker-item';
      item.textContent = component.name;
      item.addEventListener('click', () => {
        closePicker();
        actions.addExistingComponentInstance(componentId);
      });
      reuseList.appendChild(item);
    }
    picker.appendChild(reuseList);
  }

  document.body.appendChild(picker);
  const anchorRect = anchor.getBoundingClientRect();
  const maxWidth = Math.min(320, window.innerWidth - 16);
  picker.style.minWidth = `${Math.min(Math.max(anchorRect.width, 220), maxWidth)}px`;
  picker.style.maxWidth = `${maxWidth}px`;

  const pickerRect = picker.getBoundingClientRect();
  const left = Math.min(
    Math.max(8, anchorRect.left),
    Math.max(8, window.innerWidth - pickerRect.width - 8),
  );
  const top = anchorRect.bottom + 6;
  picker.style.left = `${left}px`;
  picker.style.top = `${Math.min(top, window.innerHeight - pickerRect.height - 8)}px`;

  requestAnimationFrame(() => {
    document.addEventListener('pointerdown', onPickerOutsideClick, true);
  });
}
